import(/* webpackMode: "eager" */ "/app/src/app/docs/error.tsx");
